module.exports = __webpack_public_path__ + "img/tubiao1_334_335.2af80115.png";